import { TransactionStatus } from '~/types'

export enum TRANSACTION_TYPE {
  BANK_TRANSFER_IN = 'Deposit',
  BANK_TRANSFER_OUT = 'Withdrawal',
  BLOCKCHAIN_TRANSFER_IN = 'Stablecoin Deposit',
  BLOCKCHAIN_TRANSFER_OUT = 'Stablecoin Withdrawal',
  MINT = 'Mint',
  STABLECOIN_SWAP = 'Stablecoin Swap',
  PAYMENT_TRANSFER = 'Payment/Transfer',
  EARN_ADD_FUNDS = 'Add funds',
  EARN_REMOVE_FUNDS = 'Remove funds',
  OTC = 'Otc',
}

export const TRANSACTION_TYPE_TITLE: Record<string, string> = {
  [TRANSACTION_TYPE.BANK_TRANSFER_IN]: 'Bank Transfer In',
  [TRANSACTION_TYPE.BANK_TRANSFER_OUT]: 'Bank Transfer Out',
  [TRANSACTION_TYPE.BLOCKCHAIN_TRANSFER_IN]: 'Blockchain Transfer In',
  [TRANSACTION_TYPE.BLOCKCHAIN_TRANSFER_OUT]: 'Blockchain Transfer Out',
  [TRANSACTION_TYPE.MINT]: 'Mint',
  [TRANSACTION_TYPE.STABLECOIN_SWAP]: 'Swap',
  [TRANSACTION_TYPE.EARN_ADD_FUNDS]: 'Add funds',
  [TRANSACTION_TYPE.EARN_REMOVE_FUNDS]: 'Remove funds',
  [TRANSACTION_TYPE.OTC]: 'OTC Trade',
}

export enum TRANSACTION_TYPE_TAB {
  FUNDING = 'funding',
  SWAP = 'swap',
  OTC = 'otc',
}

export type TransactionAmount = {
  prefix: string
  postfix: string
}

export type TransactionDescription = Record<string, string>

export type Transaction = {
  accountHolderName?: string
  amount: TransactionAmount
  blockedReasons: string | null
  createdAt: string
  currency: { source: string; destination: string }
  description: TransactionDescription
  fee: string
  isDeclarationRequired: boolean | null
  key: number
  method: string
  netAmount: TransactionAmount
  network: string | null
  tax?: string
  transactionHash?: string | null
  transactionHashUrl?: string | null
  transactionId: string
  transactionStatus: TransactionStatus
  transactionType: TRANSACTION_TYPE
}

export enum TRANSACTIONS_ACTIONS {
  SET_LATEST_PERSONAL_TRANSACTIONS = 'TRANSACTIONS_ACTIONS.SET_LATEST_PERSONAL_TRANSACTIONS',
}

export enum STRAITSX_TRANSACTIONS_ACTIONS {
  SET_LATEST_TRANSACTIONS = 'STRAITSX_TRANSACTIONS_ACTIONS.SET_LATEST_TRANSACTIONS',
}

type SetLatestPersonalTransactions = {
  type: typeof TRANSACTIONS_ACTIONS.SET_LATEST_PERSONAL_TRANSACTIONS
  latestPersonalTransactions: Transaction[] | null
}

type SetLatestTransactions = {
  type: typeof STRAITSX_TRANSACTIONS_ACTIONS.SET_LATEST_TRANSACTIONS
  latestTransactions: Transaction[] | null
}

export type ActionTypes = SetLatestPersonalTransactions | SetLatestTransactions
